import { c as _c } from "react/compiler-runtime";
import type React from "react";
import styles from "./index.module.scss";
interface RichTextProps {
  content: string;
  className?: string;
}
export const RichText: React.FC<RichTextProps> = t0 => {
  const $ = _c(5);
  const {
    content,
    className
  } = t0;
  const t1 = `${styles.richText} ${className || ""}`;
  let t2;
  if ($[0] !== content) {
    t2 = {
      __html: content
    };
    $[0] = content;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className={t1} dangerouslySetInnerHTML={t2} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default RichText;